<template>
    <div class="IperMatrizPeligrosDepartamento">
        {{ departamento }}
    </div>
</template>

<script>
export default {
    name: "IperMatrizPeligrosDepartamento",

    props: {
        departamento: String
    }
}
</script>